import { JourneyPlace } from '../../lib/types/models/journey-place/journey-place'
import { JourneyPlaceInput } from '../../lib/types/models/journey-place/journey-place-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createJourneyPlace(data: JourneyPlaceInput) {
  return restApiClient
    .url(constructApiUrl(API.journeyPlaces.create.url, null))
    .post<JourneyPlace, JourneyPlaceInput>(data)
}
